export const COMPONENT_NAME = "application-verification";
